<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NsryBJ/tc-custom/9780300195248.jpg?1701486925747" alt="This image is the cover for the book Men Who Lost America, The Lewis Walpole Series in Eighteenth-Century Culture and History"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Men Who Lost America, The Lewis Walpole Series in Eighteenth-Century Culture and History
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Questioning popular belief, a historian and re-examines what exactly led to the British Empire’s loss of the American Revolution.</b></p><p>The loss of America was an unexpected defeat for the powerful British Empire. Common wisdom has held that incompetent military commanders and political leaders in Britain must have been to blame, but were they? This intriguing book makes a different argument. Weaving together the personal stories of ten prominent men who directed the British dimension of the war, historian Andrew O’Shaughnessy dispels the incompetence myth and uncovers the real reasons that rebellious colonials were able to achieve their surprising victory. </p><p>In interlinked biographical chapters, the author follows the course of the war from the perspectives of King George III, Prime Minister Lord North, military leaders including General Burgoyne, the Earl of Sandwich, and others who, for the most part, led ably and even brilliantly. Victories were frequent, and in fact the British conquered every American city at some stage of the Revolutionary War. Yet roiling political complexities at home, combined with the fervency of the fighting Americans, proved fatal to the British war effort. The book concludes with a penetrating assessment of the years after Yorktown, when the British achieved victories against the French and Spanish, thereby keeping intact what remained of the British Empire.</p><p><b>“A remarkable book about an important but curiously underappreciated subject: the British side of the American Revolution. With meticulous scholarship and an eloquent writing style, O'Shaughnessy gives us a fresh and compelling view of a critical aspect of the struggle that changed the world.”—Jon Meacham, author of <i>Thomas Jefferson: The Art of Power</i></b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrew Jackson O'Shaughnessy
      </h2>
      
      <p class="authorDescription body article">Andrew Jackson O’Shaughnessy is Saunders Director of the Robert H. Smith International Center for Jefferson Studies, Monticello, and professor of history, University of Virginia. He lives in Charlottesville, VA.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Yale University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5d2f2fed